import {
  Badge,
  type BadgeProps,
  Tooltip,
  TooltipMessage,
} from '@carboncopyco/ui';
import type React from 'react';
import { useRef } from 'react';

export type BadgeWithTooltipProps = {
  tooltipText: string | React.ReactNode;
  badgeProps: BadgeProps;
};

export const BadgeWithTooltip = ({
  tooltipText,
  badgeProps,
}: BadgeWithTooltipProps) => {
  const tooltipRef = useRef<HTMLDivElement>(null);

  return (
    <div>
      <div
        className="w-fit"
        ref={tooltipRef}
      >
        <Badge {...badgeProps} />
      </div>

      <Tooltip
        fixedWidth={true}
        shadow="md"
        noArrow
        interactiveBorder={0}
        placement="top-start"
        anchorRef={tooltipRef}
        appendTo={() => document.body}
      >
        <TooltipMessage title={tooltipText} />
      </Tooltip>
    </div>
  );
};
